<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/PMReport/PMRoutePlan'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">เดือน:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reMonthCode'"
                    :name="'reMonthCode'"
                    :select2-options="reMonthOptions"
                    v-model="reMonthCode"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ปี :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reYear'"
                    :name="'reYear'"
                    :select2-options="reYearOptions"
                    v-model="reYear"
                    ref="reYear"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reDepartment'"
                    :name="'reDepartment'"
                    :select2-options="reDepartmentOptions"
                    v-model="reDepartment"
                    @selectChange="onDepartmentChange"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAgentCode'"
                    :name="'reAgentCode'"
                    :select2-options="reAgentCodeOptions"
                    v-model="reAgentCode"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="PMRoutePlanTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="11">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">เขตขาย</th>
                    <th class="all text-center">ตัวแทนจำหน่าย</th>
                    <th class="all text-center">เดือน</th>
                    <th class="all text-center">ปี</th>
                    <th class="all text-center">กำหนดการวางแผน (ครั้ง)</th>
                    <th class="all text-center">ดำเนินการได้ตามแผน (ครั้ง)</th>
                    <th class="all text-center">คิดเป็นเปอร์เซ็นต์ (%)</th>
                    <th class="all text-center">เยี่ยมนอกแผน (ครั้ง)</th>
                    <th class="all text-center">
                      ดำเนินการได้ตามการเยี่ยมนอกแผน (ครั้ง)
                    </th>
                    <th class="all text-center">
                      คิดเป็นเปอร์เซ็นต์เยี่ยมนอกแผน (%)
                    </th>
                  </tr>
                </thead>
                <tfoot v-if="isShowFooter">
                  <tr>
                    <th class="text-center" colspan="5">ยอดรวม</th>
                    <th class="text-center">
                      {{ totalEstRoutePlan | currency(" ", 0) }}
                    </th>
                    <th class="text-center">
                      {{ totalActRoutePlan | currency(" ", 0) }}
                    </th>
                    <th class="text-center">
                      {{ totalPercentRoutePlan | currency(" ", 2) }}
                    </th>
                    <th class="text-center">
                      {{ totalEstAdhoc | currency(" ", 0) }}
                    </th>
                    <th class="text-center">
                      {{ totalActAdhoc | currency(" ", 0) }}
                    </th>
                    <th class="text-center">
                      {{ totalPercentAdhoc | currency(" ", 2) }}
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;

    return {
      isShowFooter: false,
      reAaDateReq: null,
      reMonthCode: null,
      reDepartment: null,
      reAgentCode: null,
      reYear: null,
      reIsInitial: true,
      totalActRoutePlan: 0,
      totalEstRoutePlan: 0,
      totalPercentRoutePlan: 0,
      totalActAdhoc: 0,
      totalEstAdhoc: 0,
      totalPercentAdhoc: 0,
      //
      reAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: [],
              SalesAreaId: self.reDepartment,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          return data.text;
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลร้านค้า";
          },
        },
      },
      reDepartmentOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกเขตการขาย",
        allowClear: true,
        ajax: {
          url: "/Api/MasterSalesArea/FindOptions",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      // reMonthOptions: {
      //   placeholder: "กรุณาเลือก เดือน",
      //   allowClear: false,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/PM/PMRoutePlanOptions",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reMonthOptions: {
        placeholder: "กรุณาเลือกเดือน",
        allowClear: true,
        data: [
          { id: "01", text: "January", data: null },
          { id: "02", text: "February", data: null },
          { id: "03", text: "March", data: null },
          { id: "04", text: "April", data: null },
          { id: "05", text: "May", data: null },
          { id: "06", text: "June", data: null },
          { id: "07", text: "July", data: null },
          { id: "08", text: "August", data: null },
          { id: "09", text: "September", data: null },
          { id: "10", text: "October", data: null },
          { id: "11", text: "November", data: null },
          { id: "12", text: "December", data: null },
        ],
      },
      reYearOptions: {
        placeholder: "กรุณาเลือกปี",
        data: [
          // { id: new Date().getFullYear()+543, text: new Date().getFullYear()+543, data: null },
          // { id: new Date().getFullYear()+542, text: new Date().getFullYear()+542, data: null },
          // { id: new Date().getFullYear()+541, text: new Date().getFullYear()+541, data: null },
          // { id: new Date().getFullYear()+540, text: new Date().getFullYear()+540, data: null },
          // { id: new Date().getFullYear()+539, text: new Date().getFullYear()+539, data: null }
          {
            id: new Date().getFullYear(),
            text: new Date().getFullYear(),
            data: null,
          },
          {
            id: new Date().getFullYear() - 1,
            text: new Date().getFullYear() - 1,
            data: null,
          },
          {
            id: new Date().getFullYear() - 2,
            text: new Date().getFullYear() - 2,
            data: null,
          },
          {
            id: new Date().getFullYear() - 3,
            text: new Date().getFullYear() - 3,
            data: null,
          },
          {
            id: new Date().getFullYear() - 4,
            text: new Date().getFullYear() - 4,
            data: null,
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reDepartment = null;
      self.reMonthCode = null;
      self.reAgentCode = null;
      self.reYear = null;

      $("#reAgentCode")
        .val("")
        .trigger("change");

      $("#reDepartment")
        .val("")
        .trigger("change");

      $("#reMonthCode")
        .val("")
        .trigger("change");

      $("#reYear")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#PMRoutePlanTable").DataTable();
      table.draw();
    },
    onDepartmentChange() {
      this.reAgentCode = null;

      $("#reAgentCode")
        .val("")
        .trigger("change");
    },
  },
  async mounted() {
    let self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reStartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reStartDate = moment().set("date",1);
    $(self.$refs.reStartDate)
      .datepicker(
        "update",
        !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reEndDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reEndDate = moment().endOf('month');
    $(self.$refs.reEndDate)
      .datepicker(
        "update",
        !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#PMRoutePlanTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/PMRoutePlan",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            self.isShowFooter = false;
            self.totalActRoutePlan = 0;
            self.totalEstRoutePlan = 0;
            self.totalPercentRoutePlan = 0;
            self.totalActAdhoc = 0;
            self.totalEstAdhoc = 0;
            self.totalPercentAdhoc = 0;

            let jsonSearch = {
              AgentCode: self.reAgentCode,
              SalesArea: self.reDepartment,
              Month: self.reMonthCode,
              Year: self.reYear,
              IsInitial: self.reIsInitial,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[1, "asc"]],
        columns: [
          {
            data: "department",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          { data: "department", className: "text-center" },
          { data: "agentName", className: "text-center" },
          { data: "month", className: "text-center" },
          { data: "year", className: "text-center" },
          { data: "estimateRoutePlan", className: "text-center" },
          { data: "actualRoutePlan", className: "text-center" },
          { data: "percentRoutePlan", className: "text-center" },
          { data: "estimateAdhoc", className: "text-center" },
          { data: "actualAdhoc", className: "text-center" },
          { data: "percentAdhoc", className: "text-center" },
        ],
        drawCallback: function(settings) {
          self.reIsInitial = false;
          self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

          var allPage = table.DataTable().page.info().pages;
          var currentPage = table.DataTable().page.info().page + 1;

          if (allPage == currentPage) {
            self.isShowFooter = true;
            self.totalActRoutePlan = settings.json.data[0].totalActRoutePlan;
            self.totalEstRoutePlan = settings.json.data[0].totalEstRoutePlan;
            self.totalPercentRoutePlan =
              settings.json.data[0].totalPercentRoutePlan;
            self.totalActAdhoc = settings.json.data[0].totalActAdhoc;
            self.totalEstAdhoc = settings.json.data[0].totalEstAdhoc;
            self.totalPercentAdhoc = settings.json.data[0].totalPercentAdhoc;
          }
        },
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/PMRoutePlan.vue